module.exports = __webpack_public_path__ + "static/media/thumbnail.c88704d2.jpg";